<template>
	<div class="MAM_brandList">
		<!-- 表单搜索部分 -->
		<!-- <el-card class="box-card" shadow="hover">
			<el-form :inline="true" :model="formInline" class="demo-form-inline">
				<el-form-item>
					<el-input size="medium" clearable v-model="formInline.name" placeholder="请输入政策名称"></el-input>
				</el-form-item>

				<el-form-item>
					<el-button size="medium" type="primary" icon="el-icon-search" style="font-size: 12px;"
						@click="onSubmit">查询</el-button>
				</el-form-item>
			</el-form>
		</el-card> -->
		<!-- 表格部分 -->
		<el-card class="box-card" style="margin-top: 20px;" shadow="hover">
			<div style="margin-bottom: 20px;">
				<el-button size="small" type="primary" icon="el-icon-plus" @click="handleAddBrand">添加政策配置</el-button>
				<!-- <el-button size="small" type="primary" icon="el-icon-download" @click>数据导出</el-button> -->
			</div>
			<el-table :data="brandTable" size="mini" border style="width: 100%" max-height="500px"
				v-loading="loading">
					
				<el-table-column header-align="center" align="center" prop="group_name" label="档位名称"
					min-width="120"></el-table-column>	
					
				<el-table-column header-align="center" align="center" label="关联政策名称" prop="brand_name" min-width="120">
				</el-table-column>
				
				<el-table-column header-align="center" align="center" label="政策类型" prop="brand_type_name" min-width="120">
				</el-table-column>
				
				<el-table-column header-align="center" align="center" label="档位内容" min-width="120">
					<template slot-scope="scope">
						<el-button @click="handleRate(scope.row)" v-if="scope.row.is_mpos == 1" type="text" size="small">查看/编辑</el-button>
						<el-button @click="handleRate(scope.row)" v-if="scope.row.is_mpos == 2" type="text" size="small">查看</el-button>
					</template>
				</el-table-column>
				
				<el-table-column header-align="center" align="center" prop="create_time" label="创建时间"
					min-width="150"></el-table-column>

			</el-table>
			<!-- 分页部分 -->
			<paginations :currentPage="page.currentPage" :pageSize="page.pageSize" :total="page.total"
				@watchCurrent="getCurrent" @watchPageSize="getPageSize"></paginations>
		</el-card>
		<!-- 添加 -->
		<el-dialog title="添加" width="800px" :visible="addBrand" :close-on-click-modal="false" @close="handleClose">
			<el-form class="demo-form-inline" label-width="100px" :model="form" :rules="rules" ref="ruleForm">
				<el-form-item label="档位名称" prop="group_name">
					<el-input size clearable v-model="form.group_name" placeholder="请输入档位名称"
						style="width:180px;"></el-input>
				</el-form-item>
				<el-form-item label="政策类型" prop="brand_type">
					<el-select size clearable v-model="form.brand_type" placeholder="请选择政策类型" style="width:180px;">
						<el-option label="2.0政策" :value="2"></el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="政策名称" prop="brand_id">
					<el-select size clearable v-model="form.brand_id" placeholder="请选择政策名称" style="width:180px;">
						<el-option :label="item.name" :value="item.id" v-for="(item,index) in optionList"></el-option>
					</el-select>
				</el-form-item>

				<el-form-item label="档位内容配置"></el-form-item>
				<div class="tableDiv" ref="tableDiv">
					<el-table :data="form.rule_data" size="mini" border style="width: 100%" max-height="500px"
						v-loading="loading">
						<el-table-column header-align="center" align="center" label="单政策累计库存" prop="inventory"
							width="250px">
							<template slot-scope="scope">
								<div style="display: flex;justify-content: flex-start;align-items: center;">
									<el-input size="medium" clearable v-model="scope.row.inventory"
										placeholder="请输入单政策累计库存"
										@input="scope.row.inventory=scope.row.inventory.replace(/[^\d.]/g, '').replace(/^\./g, '').replace('.', '$#$').replace(/\./g, '').replace('$#$', '.')">
										<template slot="append">台以内</template>
									</el-input>
								</div>
							</template>
						</el-table-column>
						<el-table-column header-align="center" align="center" label="结算价格（%）" prop="profit">
							<template slot-scope="scope">
								<el-input size="medium" clearable v-model="scope.row.profit" placeholder="请输入结算价格"
									@input="scope.row.profit=scope.row.profit.replace(/[^\d.]/g, '').replace(/^\./g, '').replace('.', '$#$').replace(/\./g, '').replace('$#$', '.')"></el-input>
							</template>
						</el-table-column>
						<el-table-column header-align="center" align="center" label="流量卡奖励比例（%）" prop="flow_fee">
							<template slot-scope="scope">
								<el-input size="medium" clearable v-model="scope.row.flow_fee" placeholder="请输入流量卡奖励比例"
									@input="scope.row.flow_fee=scope.row.flow_fee.replace(/[^\d.]/g, '').replace(/^\./g, '').replace('.', '$#$').replace(/\./g, '').replace('$#$', '.')"></el-input>
							</template>
						</el-table-column>
						<el-table-column header-align="center" align="center" label="自由调价奖励比例（%）" prop="freedom_fee">
							<template slot-scope="scope">
								<el-input size="medium" clearable v-model="scope.row.freedom_fee" placeholder="请输入自由调价奖励比例"
									@input="scope.row.freedom_fee=scope.row.freedom_fee.replace(/[^\d.]/g, '').replace(/^\./g, '').replace('.', '$#$').replace(/\./g, '').replace('$#$', '.')"></el-input>
							</template>
						</el-table-column>
                        <el-table-column header-align="center" align="center" label="平台涨价奖励比例（%）" prop="platform_up_ratio">
                        	<template slot-scope="scope">
                        		<el-input size="medium" clearable v-model="scope.row.platform_up_ratio" placeholder="请输入平台涨价奖励比例"
                        			@input="scope.row.platform_up_ratio=scope.row.platform_up_ratio.replace(/[^\d.]/g, '').replace(/^\./g, '').replace('.', '$#$').replace(/\./g, '').replace('$#$', '.')"></el-input>
                        	</template>
                        </el-table-column>

					</el-table>
				</div>
			</el-form>
			<span slot="footer" class="dialog-footer">
				<el-button @click="handleClose()">取 消</el-button>
				<el-button type="primary" @click="addSubmit('ruleForm')">确 定</el-button>
			</span>
		</el-dialog>
		<!-- 查看 -->
		<catinfo :infoState="infoState" v-if="infoState" :group_id="group_id" :is_mpos="is_mpos"  @setInfoState="setInfoState" />
	</div>
</template>

<script>
	import paginations from '../../../components/pagination/paginations';
	import catinfo from './components/catinfo'
	export default {
		name: "gearConfigurationList",
		inject: ['reload'],
		components: {
			paginations,
			catinfo
		},
		data() {
			return {
				formInline: {
					name: '',
					brand_type: '',
				},
				brandTable: [],
				page: {
					currentPage: 1, //当前页码
					pageSize: 10, //条数
					total: 0 //总数
				},
				infoState:false,
				group_id:0,
				loading: true,
				//新增
				addBrand: false,
				optionList: [],
				form: {
					brand_type: 2,
					rule_data: [{
							"inventory": 0,
							"profit": 0,
							"flow_fee": 0,
							"freedom_fee": 0,
                            'platform_up_ratio':0
						},
						{
							"inventory": 0,
							"profit": 0,
							"flow_fee": 0,
							"freedom_fee": 0,
                            'platform_up_ratio':0
						},
						{
							"inventory": 0,
							"profit": 0,
							"flow_fee": 0,
							"freedom_fee": 0,
                            'platform_up_ratio':0
						}
					]
				},
				rules: {
					group_name: [{
						required: true,
						message: '请输入档位名称',
						trigger: 'blur'
					}, ],
					brand_type: [{
						required: true,
						message: '请选择政策类型',
						trigger: 'change'
					}],
					brand_id: [{
						required: true,
						message: '请选择政策名称',
						trigger: 'change'
					}],
				}
			}
		},
		mounted() {
			this.brandList()
			this.getData({
				page: this.page.currentPage,
				limit: this.page.pageSize,
			})
		},
		methods: {
			/**
				*获取数据  
			*/
			handleRate(row){
				this.group_id = row.id
				this.is_mpos = row.is_mpos
				this.infoState = true;
			},
			//设置状态
			setInfoState(state){
				this.infoState = state
				this.getData({
					page: 1,
					limit: this.page.pageSize,
				})
			},
			//档位配置  提交
			addSubmit(formName) {
				console.log(this.form)
				for (let i in this.form.rule_data) {
					if (this.form.rule_data[i].profit > 1) {
						this.$message({
							type: 'error',
							message: '结算价格不能超过1',
							duration: 2000,
						})
						break;
					}
					if (this.form.rule_data[i].flow_fee > 100) {
						this.$message({
							type: 'error',
							message: '流量卡奖励比例不能超过100',
							duration: 2000,
						})
						break;
					}
					if (this.form.rule_data[i].freedom_fee > 100) {
						this.$message({
							type: 'error',
							message: '自由调价奖励比例不能超过100',
							duration: 2000,
						})
						break;
					}
                    if (this.form.rule_data[i].platform_up_ratio > 100) {
                    	this.$message({
                    		type: 'error',
                    		message: '平台涨价奖励比例不能超过100',
                    		duration: 2000,
                    	})
                    	break;
                    }
				}
				this.$refs[formName].validate((valid) => {
					if (valid) {
						this.$api.post("userlevel/saveUserLevelRule", this.form, res => {
							if (res.code == 0) {
								this.addBrand = false;
								this.$message({
									type: 'success',
									message: res.msg,
									duration: 2000,
								})
								this.$refs[formName].resetFields();
								this.form = {
									brand_type: 2,
									rule_data: [{
											"inventory": 0,
											"profit": 0,
											"flow_fee": 0,
											"freedom_fee": 0,
                                            'platform_up_ratio':0
										},
										{
											"inventory": 0,
											"profit": 0,
											"flow_fee": 0,
											"freedom_fee": 0,
                                            'platform_up_ratio':0
										},
										{
											"inventory": 0,
											"profit": 0,
											"flow_fee": 0,
											"freedom_fee": 0,
                                            'platform_up_ratio':0
										}
									]
								};
								this.getData({
									page: 1,
									limit: this.page.pageSize,
								})
							}else{
								this.$message({
									type: 'error',
									message: res.msg,
									duration: 2000,
								})
							}
						})
					}
				});
			},
			//打开  关闭   新增配置
			handleAddBrand() {
				this.addBrand = true;
			},
			handleClose() {
				this.addBrand = false;
				this.$refs.ruleForm.resetFields();
				this.form = {
					brand_type: 2,
					rule_data: [{
							"inventory": 0,
							"profit": 0,
							"flow_fee": 0,
							"freedom_fee": 0,
                            'platform_up_ratio':0
						},
						{
							"inventory": 0,
							"profit": 0,
							"flow_fee": 0,
							"freedom_fee": 0,
                            'platform_up_ratio':0
						},
						{
							"inventory": 0,
							"profit": 0,
							"flow_fee": 0,
							"freedom_fee": 0,
                            'platform_up_ratio':0
						}
					]
				};
			},
			//搜索
			onSubmit() {
				this.loading = true;
				// 表单提交
				this.getData({
					page: 1,
					limit: this.page.pageSize,
				})
			},

			//获取2.0政策
			brandList() {
				this.$api.post("userlevel/selBrandList", {}, res => {
					this.optionList = res.data;
				})
			},

			//分页
			getCurrent(page) {
				// 获取当前页修改的值
				this.page.currentPage = page;
				this.loading = true;
				this.getData({
					page: this.page.currentPage,
					limit: this.page.pageSize,
				})
			},
			getPageSize(limit) {
				// 获取条数发生改变的值
				this.page.pageSize = limit;
				this.loading = true;
				this.getData({
					page: this.page.currentPage,
					limit: limit,
				})
			},
			getData(params) {
				this.$api.post("userlevel/selUserLevelGroupList", params, res => {
					let data = res.data;
					this.page.total = data.total; //总数
					this.brandTable = data.data;
					//渲染结束后取消加载
					this.loading = false;
				})
			},
		}
	};
</script>

<style lang="scss" scoped>
	.tableDiv {
		overflow-x: scroll;
	}
	.el-form-item {
		margin-bottom: 20px !important;
	}
</style>